import PropTypes from 'prop-types';
import React from 'react';
import LinkTransition from '../common/link-transition';

import { NavigationListBase, NavigationTopNav, NavigationTopItem } from './styled.js';

const NavigationTop = ({ dark }) => (
  <NavigationTopNav>
    <NavigationListBase>
      <NavigationTopItem
        dark={dark}
      >
        <LinkTransition
          to='/about'
        >
          About us
        </LinkTransition>
      </NavigationTopItem>
      <NavigationTopItem
        dark={dark}
      >
        <a href="https://help.ludus.one/" target="_blank" rel="noopener noreferrer">
          Help &amp; doc
        </a>
      </NavigationTopItem>
      {/* <NavigationTopItem
        dark={dark}
      >
        <a href="https://blog.ludus.one/" target="_blank" rel="noopener noreferrer">
          Blog
        </a>
      </NavigationTopItem> */}
      <NavigationTopItem
        dark={dark}
      >
        <a href="https://ludus.kampsite.co/" target="_blank" rel="noopener noreferrer">
          Roadmap
        </a>
      </NavigationTopItem>
      <NavigationTopItem
        dark={dark}
      >
        <a href="https://headwayapp.co/ludus-changelog" target="_blank" rel="noopener noreferrer">
          Changelog
        </a>
      </NavigationTopItem>
    </NavigationListBase>
  </NavigationTopNav>
)

NavigationTop.propTypes = {
  dark: PropTypes.bool,
}

NavigationTop.defaultProps = {
  dark: false
}

export default NavigationTop
